import { render, staticRenderFns } from "./stacked-bar-chart.vue?vue&type=template&id=066cc544&scoped=true"
import script from "./stacked-bar-chart.ts?vue&type=script&lang=ts&external"
export * from "./stacked-bar-chart.ts?vue&type=script&lang=ts&external"
import style0 from "./stacked-bar-chart.scss?vue&type=style&index=0&id=066cc544&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066cc544",
  null
  
)

export default component.exports